<!-- BEGIN #app -->
<div id="app" class="app" [ngClass]="{'app-sidebar-collapsed':app.sideBarCollapsed, 'app-sidebar-mobile-toggled': app.menuOpen}">
  <app-header [showNavigation]="true"></app-header>
  <app-navigation [collapse]="app.sideBarCollapsed"></app-navigation>
  
  <!-- BEGIN #content -->
  <div id="content" class="app-content">

        <router-outlet></router-outlet>
      
  </div>
  <!-- END #content -->
</div>
<!-- END #app -->